import React from "react";
import { AsyncSelectField, DateTimeField, TextField, LanguageSelect, Label } from "../../components/FormControl";

import {
  Row,
  Col,
  Button,
  Card,
  CardHeader,
  CardBody
} from 'reactstrap';

import { history, loginInfo, setUserType, setLocation } from '../../global';

const locationTypeMapping = {
  'W': 'Workshop',
  'L': 'Workshop',
  'S': 'Shop',
}

const MainFunctionButton = props => (
  <Button color="light" className="kiosk-btn" onClick={() => {
    setUserType(props.userType)
    //Reset Location if previous location type not align with current location type
    if (loginInfo.LocationType != locationTypeMapping[props.userType])
      setLocation({});
    openForm(props.path);
  }}>
    <div className="kiosk-label">
      {props.display}
    </div>
    <hr />
    <div>
      <i className={props.icon} />
    </div>
  </Button>
)


const openForm = (pathname) => {
  history.push(pathname);
}

export default class extends React.Component {

  render() {
    const { standardProps, isAfterSave, onSubmit, getFormData, ...restProps } = this.props;

    return (
      <div id="KioskContainer" className="app menu-container">
        <div className="kiosk-btn-group mt-auto mb-auto">
          <Row style={{ marginLeft: '15px', marginRight: '15px' }}>
            {[{
              display: <Label>Shop</Label>,
              userType: 'S',
              show: loginInfo.UserTypeList.find(obj => obj.UserType == 'S'),
              path: '/Kiosk/Home',
              //icon: "create-pr-icon"
              icon: "shop-icon"
            }, {
              display: <Label>Procurement</Label>,
              userType: 'P',
              show: loginInfo.UserTypeList.find(obj => obj.UserType == 'P'),
              path: '/Home/Procurement',
              //icon: "pr-search-icon"
              icon: "procurement-icon"
            }, {
              display: <Label>Workshop</Label>,
              userType: 'W',
              show: loginInfo.UserTypeList.find(obj => obj.UserType == 'W'),
              path: '/Home/Workshop',
              //icon: "good-receive-icon"
              icon: "workshop-icon"
            }, {
              display: <Label>Product Line</Label>,
              userType: 'L',
              show: loginInfo.UserTypeList.find(obj => obj.UserType == 'L'),
              path: '/Kiosk/ProductLineHome',
              //icon: "good-receive-icon"
              icon: "production-line-icon"
            }, {
              display: <Label>Management</Label>,
              userType: 'M',
              show: loginInfo.UserTypeList.find(obj => obj.UserType == 'M'),
              path: '/HomeManagement',
              //icon: "good-receive-icon"
              icon: "management-icon"
            },
            {
              display: <Label>Task Overview</Label>,
              userType: 'M',
              show: loginInfo.UserTypeList.find(obj => obj.UserType == 'M'),
              path: '/Home/TaskOverview',
              icon: "task-overview-icon"
            }
            ].map((obj, index) => (
              (obj.show && <Col xs="12" md="4" className="mt-4" key={index}>
                <MainFunctionButton {...obj} />
              </Col>)
            ))
            }


          </Row>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/views/Home/Home.Menu.js